'use client';

import { useTranslations } from 'next-intl';
import { getCookie } from '../utils/cookies';
import getOption from '../utils/getOption';
import { MdModeEdit } from 'react-icons/md';

export default function AdminEditButton({ id }: { id: number }) {
  const show = getCookie('adminEditButtons');
  const url = getOption('ADMIN_URL');
  const t = useTranslations('general');
  if (!show) {
    return null;
  }

  return (
    <a
      href={`${url}/ads/${id}`}
      target='_blank'
      className='my-2 inline-flex items-center gap-2 rounded border border-brand bg-brand p-2 font-bold text-black hover:bg-black hover:text-white'
    >
      <MdModeEdit /> {t('edit')}
    </a>
  );
}
